module.exports = __webpack_public_path__ + "img/logo_red_2.a5658850.png";